import Route from 'cio/routes/base';
import { allSettled } from 'rsvp';
import { inject as service } from '@ember/service';

export default class BaseDeliveryRoute extends Route {
  @service messageSettings;
  @service store;

  model(params) {
    return this.store.findRecord('delivery', params.delivery_id, { reload: true });
  }

  afterModel(model) {
    let primary = ['detail'];
    let secondary = [
      'template',
      'customer',
      'campaign',
      'broadcastTrigger',
      'newsletter',
      'action',
      'email',
      'variation',
    ];
    let reloads = primary.map((x) => model.belongsTo(x).reload());
    let fetches = secondary.map((x) => model.get(x));

    return allSettled([...reloads, ...fetches, this.messageSettings.loadMessagingLimit.perform()]);
  }
}
